import*as t from"react";var a=function(){return{onTouchStartEvent:t.useCallback((function(t,a){a&&a(t)}),[])}};export{a as default};
//# sourceMappingURL=useTouchStart.mjs.map
